import { CrudServiceBase } from './CrudServiceBase';
import { FileParseFormatDto } from '@/models/file-parsing/FileParseFormatDto';
import { LoadOptions } from 'devextreme/data/load_options';
import { FileParseFormatFileExtensionDto } from '@/models/file-parsing/FileParseFormatFileExtensionDto';
import { FileParseTargetColumnOptionDto } from '@/models/file-parsing/FileParseTargetColumnOptionDto'


export class FileParseFormatService extends CrudServiceBase<FileParseFormatDto> {
  constructor() {
    super('/api/FileParseFormats');
  }

  async getColumnFormats(fileParseFormatId: Guid, options: LoadOptions) : Promise<any> {
    return await this.client.getPostData(`/${fileParseFormatId}/FileParseColumnFormats/search`, options);
  }
  async getFileExtensions() : Promise<Array<string>> {
    return await this.client.get(`/file-extensions/`);
  }
  async getDataTypes() : Promise<Array<string>> {
    return await this.client.get(`/data-types/`);
  }
  async checkFileParseFormatName(fileParseFormatName: string): Promise<any>{
    return await this.client.get(`?fileParseFormatName=${fileParseFormatName}`);
  }
  async getTargetColumnNameOptions(): Promise<FileParseTargetColumnOptionDto[]>{
    return await this.client.get(`/target-column-options/`);
  }
}